export const ACCOUNT_TAGS_OPEN_VIEW_ENTITIES_MODAL = "ACCOUNT_TAGS_OPEN_VIEW_ENTITIES_MODAL";

export const ACCOUNT_TAGS_VIEW_ENTITIES_SEARCH_ENTITIES = "ACCOUNT_TAGS_VIEW_ENTITIES_SEARCH_ENTITIES";
export const ACCOUNT_TAGS_VIEW_ENTITIES_SEARCH_ENTITIES_RESPONSE = "ACCOUNT_TAGS_VIEW_ENTITIES_SEARCH_ENTITIES_RESPONSE";